var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5013 0.833984H3.33464C2.41797 0.833984 1.66797 1.58398 1.66797 2.50065V13.334C1.66797 13.7923 2.04297 14.1673 2.5013 14.1673C2.95964 14.1673 3.33464 13.7923 3.33464 13.334V3.33398C3.33464 2.87565 3.70964 2.50065 4.16797 2.50065H12.5013C12.9596 2.50065 13.3346 2.12565 13.3346 1.66732C13.3346 1.20898 12.9596 0.833984 12.5013 0.833984ZM12.993 4.65898L17.018 8.68398C17.3263 8.99232 17.5013 9.41732 17.5013 9.85898V17.5006C17.5013 18.4173 16.7513 19.1673 15.8346 19.1673H6.65964C5.74297 19.1673 5.0013 18.4173 5.0013 17.5006L5.00964 5.83398C5.00964 4.91732 5.7513 4.16732 6.66797 4.16732H11.8096C12.2513 4.16732 12.6763 4.34232 12.993 4.65898ZM12.5013 10.0007H16.2513L11.668 5.41732V9.16732C11.668 9.62565 12.043 10.0007 12.5013 10.0007Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateReport);
export default __webpack_public_path__ + "static/media/create_report.ee6efda5a83d4665ff1c171da108ecb6.svg";
export { ForwardRef as ReactComponent };